export const STATUS_ERROR = -1;
export const STATUS_IDLE = 0;
export const STATUS_IN_PROGRESS = 1;
export const STATUS_DONE = 2;
